var Base = require('_js/base'),
  $ = require('jquery');

function LoginReset() {
  this.init();
}

LoginReset.prototype = new Base();

LoginReset.prototype.init = function() {
  $('input[name="toggle-options"]').bind('change', function() {
    $('.toggle-content').hide();
    $('#tg-' + $(this).val()).show();
    $('.reset-login-input').val('');
  });
};

module.exports = LoginReset;
